import { Navigate, Route, Routes } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { ContentWrapper, Main, PageWrapper } from './index.styles';

import Footer from '../../footer';
import Header from '../../header';
import OnboardingDetails from './details';
import OnboardingPlan from './plan';

import { maybeCurrentBusinessState } from '../../../store';

export default function OnboardingPage() {
  const maybeCurrentBusiness = useAtomValue(maybeCurrentBusinessState);

  const hasPlan = !maybeCurrentBusiness || Boolean(maybeCurrentBusiness.plan_id);

  if (hasPlan) {
    return <Navigate to="/" />;
  }

  return (
    <PageWrapper>
      <Header />
      <Routes>
        <Route
          element={
            <ContentWrapper wider>
              <Main>
                <OnboardingPlan />
              </Main>
            </ContentWrapper>
          }
          path="plan"
        />
        <Route
          element={
            <ContentWrapper>
              <Main>
                <OnboardingDetails />
              </Main>
            </ContentWrapper>
          }
          path="details"
        />
        <Route element={<Navigate to="plan" />} path="*" />
      </Routes>
      <Footer />
    </PageWrapper>
  );
}
